import React from "react";
import { Topbar } from "@components";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import styled from "styled-components";
import {
  AppleFilled,
  FacebookFilled,
  PlayStoreFilled,
  ViberFilled,
  YoutubeFilled,
  ApkFilled,
  TelegramFilled,
} from "@assets";
import { Space } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const RootContainer = styled.div`
  min-height: calc(100vh - 118px);
  padding: 24px 16px;
  text-align: center;
  overflow: hidden;

  svg {
    cursor: pointer;
  }
`;

const Title = styled.div`
display: inline-block;
padding: 7px 32px;
margin-bottom: 12px;

border-radius: 24px;
background-color: #EFEFEF;
font-size: 14px;
font-style: normal;
font-weight: 400;
line-height: normal;
color: #101415;
`;

const SocialWrapper = styled(Space)`
gap: 24px !important;
margin-bottom: 36px;

svg {
  width: 100%;
  height: auto;
}
`;

const DownloadWrapper = styled(Space).attrs({
  direction: 'vertical',
})`
gap: 13px !important;
`;

const AppDownload = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { social_links } = useSelector(state => state.app.settings);

  const goBack = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}`);
  };

  const Link = ({ url, children }) => (
    <a href={url} target="_blank" rel="noreferrer noopen">
      {children}
    </a>
  );

  return (
    <>
      <Topbar title={t("home.appDownloadTitle")} goBack={goBack} />
      <RootContainer>
        <Title>{t("home.appDownloadSubTitle1")}</Title>
        <br />
        <SocialWrapper>
          <Link url={social_links?.fb_link}>
            <FacebookFilled />
          </Link>
          <Link url={social_links?.viber_link}>
            <ViberFilled />
          </Link>
          <Link url={social_links?.telegram_link}>
            <TelegramFilled />
          </Link>
          <Link url={social_links?.youtube_link}>
            <YoutubeFilled />
          </Link>
        </SocialWrapper>

        <br />
        <Title>{t("home.appDownloadSubTitle2")}</Title>
        <br />
        <DownloadWrapper>
          <Link url={social_links?.app_store_link}>
            <AppleFilled />
          </Link>
          <Link url={social_links?.play_store_link}>
            <PlayStoreFilled />
          </Link>
          <Link url={social_links?.download_link}>
            <ApkFilled />
          </Link>
        </DownloadWrapper>
      </RootContainer>
    </>
  );
};

export default AppDownload;
